import React from 'react';
import { withResourceTextSupport, IUseResourceTexts } from '../../Components/ResourceText';

export interface IValidationErrorDisplayProps {
	errors: any;
	fieldName: string;
	type?: string;
	message?: string;
}

export const ValidationErrorDisplay = withResourceTextSupport(function (
	props: IValidationErrorDisplayProps & IUseResourceTexts,
) {
	if (!props.errors[props.fieldName] || (props.type && props.errors[props.fieldName].type !== props.type)) {
		return null;
	}

	return (
		<div className="input-basic__error">
			{props.message || props.getResourceText('Application_Validation_RequiredField')}
		</div>
	);
});
